module.exports = __webpack_public_path__ + "img/audit.bf7a8a4c.png";